import Vue from 'vue'
import Router from 'vue-router'
import global from '@/core/global/global'
var param = global.global.getParam();


Vue.use(Router)


import manage_routers from "./manage_routers"//登录注册

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  // return originalPush.call(this, location).catch(err => err)
  return originalPush.call(this, location)
}

var projects = [
  manage_routers,
]

var routes = (branches) => {
  var merge = [];
  branches.map(function (item) {
    merge.push.apply(merge, item);
  })
  return merge;
}
var router = new Router({
  routes: routes(projects)
})

const getPridFromRoute = (to) => {
  if (to && to.query && to.query.prid) {
    return to.query.prid;
  }
  const search = window.location.search || "";
  const searchParams = search.replace(/^\?/, "").split("&");
  for (let i = 0; i < searchParams.length; i++) {
    const item = searchParams[i];
    if (!item) continue;
    const arr = item.split("=");
    if (arr[0] === "prid") {
      return arr[1] ? decodeURIComponent(arr[1]) : "";
    }
  }
  return sessionStorage.getItem("perId") || global.global.perId || "";
}

router.beforeEach((to, from, next) => {
  const isOtherSettings = to.path === '/manage/otherSettings'
  const isMobile = !global.global.isPC()
  const tab = to.query && to.query.tab
  if (isOtherSettings && tab === 'certification' && isMobile) {
    const prid = getPridFromRoute(to)
    const authH5Url = global.global.authH5Url
    if (prid) {
      window.location.href = `${authH5Url}authentication?prid=${encodeURIComponent(prid)}`
    } else {
      window.location.href = `${authH5Url}authentication`
    }
    return
  }

  if (to.path == '/manage/mySubmission') {
    next()
  } else if (to.path == '/') {
    sessionStorage.clear()
    next({ path: '/loginAdmin' })
  } else {
    next()
  }

})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js